import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Item } from './item/Item.js';
import styles from './RadioCardGroup.module.scss.js';
import { RadioCardGroupContextProvider, DEFAULT_VARIANT } from './RadioCardGroupContext.js';

var RadioCardGroup = function (_a) {
    var _b;
    var children = _a.children, ariaLabelledby = _a["aria-labelledby"], _c = _a.variant, variant = _c === void 0 ? DEFAULT_VARIANT : _c, className = _a.className, style = _a.style;
    return (jsx("div", __assign({ role: "group", "aria-labelledby": ariaLabelledby, className: clsx(className, (_b = {},
            _b[styles.radioGroupHorizontal] = variant === 'withoutRadioHorizontal',
            _b)), style: style }, { children: jsx(RadioCardGroupContextProvider, __assign({ value: { variant: variant } }, { children: children })) })));
};
RadioCardGroup.Item = Item;

export { RadioCardGroup };
